import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import get from 'lodash/get';
import * as constants from '../Authorization/constants';
import List from '../../components/List';
import Item from '../../components/Item';
import Icon from '../../components/Icon';
import Modal from '../../components/Modal';
import SubscriptionActive from '../../components/SubscriptionActive';
import SubscriptionInactive from '../../components/SubscriptionInactive';
import FeatureEnabled from '../../components/FeatureEnabled';
import HighSchoolDetailDisplay from '../HighSchoolDetailsDisplay';

import './styles.css';

class AvailabilityHSDetails extends React.PureComponent {
  static propTypes = {
    distanceWrapper: PropTypes.shape({
      distance: PropTypes.shape({
        text: PropTypes.string,
      }),
      toSchool: PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string,
        interestedStudents: PropTypes.number,
        general: PropTypes.shape({
          field_hs_na_nces_id: PropTypes.string,
        }),
        naviance: PropTypes.shape({
          field_hs_na_nguid: PropTypes.string,
          field_hs_elna_phone: PropTypes.string,
        }),
        address: PropTypes.shape({
          field_hs_elna_address_line1: PropTypes.string,
          field_hs_elna_state_latest: PropTypes.string,
          field_hs_elna_city: PropTypes.string,
          field_hs_na_country_name: PropTypes.string,
        }),
        repVisitsAccount: PropTypes.shape({
          webInstructions: PropTypes.string,
          primaryContact: PropTypes.shape({
            field_first_name: PropTypes.string,
            field_last_name: PropTypes.string,
            mail: PropTypes.string,
          }),
        }),
      }),
    }),
  };

  render() {
    const { distanceWrapper } = this.props;
    const row = get(distanceWrapper, 'toSchool');
    const mailto = get(row, 'repVisitsAccount.primaryContact.mail');
    const interestedStudents = get(row, 'interestedStudents', 0);
    let email = get(row, 'repVisitsAccount.primaryContact.mail');
    if (email && email.length > 26) {
      const diff = (email.length - 26);
      const atIndex = email.indexOf('@');
      email = email.replace(email.slice(atIndex-diff, atIndex), '...');
    }
    return (
      <Item.Group>
        <Item>
          <Item.Content>
            <SubscriptionActive anyOf={constants.REP_VISITS_SUBSCRIPTION}>
              <Item.Header as="h3" styleName="hsLink">
                { /* eslint-disable jsx-a11y/anchor-is-valid */}
                <Modal
                  basic
                  styleName="details-modal"
                  trigger={<Link styleName="hsLink" to="">{row.name}</Link>}
                  closeIcon={<Icon name="close" styleName="details-modal-close" />}
                >
                  <HighSchoolDetailDisplay
                    contactType="visits"
                    id={get(row.naviance, 'field_hs_na_nguid') || get(row.general, 'field_hs_na_nces_id')}
                  />
                </Modal>
              </Item.Header>
            </SubscriptionActive>
            <SubscriptionInactive allOf={constants.REP_VISITS_SUBSCRIPTION}>
              <Item.Header>{row.name}</Item.Header>
            </SubscriptionInactive>
            <Item.Description>
              <List>
                <List.Item styleName="info-line">
                  {row.address.field_hs_elna_address_line1}
                </List.Item>
                <List.Item styleName="info-line">
                  {row.address.field_hs_elna_city && `${row.address.field_hs_elna_city}, `}
                  {row.address.field_hs_elna_state_latest}
                </List.Item>
                <List.Item styleName="info-line">
                  {row.address.field_hs_na_country_name}
                </List.Item>
              </List>
            </Item.Description>
            <Item.Extra>
              <List>
                <List.Item styleName="info-line distance">{distanceWrapper.distance.text}</List.Item>
                <List.Item styleName="info-line phone">{row.naviance.field_hs_elna_phone}</List.Item>
                <List.Item styleName="email">
                  {email && <Link styleName="hsLink" href={`mailto:${mailto}`}>{email}</Link>}
                </List.Item>
              </List>
            </Item.Extra>
            <Item.Extra>
              <FeatureEnabled allOf={constants.REPVISITS_LOOKING_FOR_YOU_COUNT}>
                <SubscriptionActive anyOf={constants.REP_VISITS_SUBSCRIPTION}>
                  <List.Item styleName="interested-line">
                    <span>Interested students:</span> {interestedStudents > 10 ? (<div styleName="interested-students">{interestedStudents}</div>) : 'N/A'}
                  </List.Item>
                </SubscriptionActive>
              </FeatureEnabled>
            </Item.Extra>
            <Item.Description>
              {row.repVisitsAccount && row.repVisitsAccount.webInstructions}
            </Item.Description>
          </Item.Content>
        </Item>
      </Item.Group>
    );
  }
}

export default AvailabilityHSDetails;
